import { EditClientAccountRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useEditClientAccount() {
  const api = useApi();
  const [editing, setEditing] = useState(false);

  async function editClientAccount(params: EditClientAccountRequest) {
    try {
      setEditing(true);
      const res = await api.editClientAccount(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setEditing(false);
    }
  }

  return { editing, editClientAccount };
}
